import moment from 'moment';

export default function disableSpecificDates(curr, dates, range) {
    if (range) return true
    if (!dates || dates.length === 0) {
        return curr && curr > moment().endOf('day');
    }
    const tooLate = dates[0] && curr.diff(dates[0], 'days') > 7;
    const tooEarly = dates[1] && dates[1].diff(curr, 'days') > 7;
    return ((tooEarly || tooLate) || curr > moment().endOf('day'))
};